import styled from 'styled-components';

import { screen } from '@/helpers/screen';

//components
import { Container } from 'components/Grid';

export const VideoHeroWrapper = styled.section`
  z-index: 2;

  margin-top: -70px;

  ${screen.md} {
    margin-top: -80px;
  }

  ${screen.lg} {
    margin-top: -110px;
  }

  ${screen.xxlg} {
    margin-top: -130px;
  }
`;

export const ContainerStyled = styled(Container)`
  position: relative;

  width: 100%;
  max-width: calc(100% - 38px);

  padding: 0;

  ${screen.md} {
    width: 100%;
    max-width: calc(100% - 168px);
  }

  ${screen.lg} {
    width: 100%;
    max-width: calc(100% - 266px);
  }

  ${screen.xxlg} {
    width: 100%;
    max-width: calc(100% - 686px);
  }
`;

export const Thumb = styled.div`
  position: relative;
`;

export const ThumbImage = styled.img`
  max-width: 100%;
  height: auto;
  margin: auto;

  transition: all 0.1s ease-in-out;
`;
